/**
 * 下载跳转 —— 与重构前保持完全一致的接口地址
 */
export function downloadLatestApp(type) {
  const appName = type === "kami" ? "达人连连-卡密版" : "达人连连";
  try {
    window.open(`https://dcjl.dcjling.com/api/getapp/${appName}/`, "_blank", "noopener");
  } catch (e) {
    alert("获取版本号失败，请稍后重试");
  }
}
